const common: Record<string, Record<string, string> | string> = {
    responsibleExecutor: 'Responsible executor',
};

export default common;
